import React from 'react';
import { Vimeo } from 'components/Vimeo';
import app from 'new-ui/app';
import Button from 'new-ui/Components/Button';
import { THEMES } from 'new-ui/constants';
import NextIcon from 'assets/icons/next.svg';
import InfinityLoader from 'new-ui/Components/InfinityLoader';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import { GA } from './UploadFormConstants';
import { getVimeoId } from './UploadFormUtils';

export const AiAnimate = ({ onSkip, onEnd }) => {
  const { t } = useTranslation();
  return (
    <div className="upload-preloader">
      <div className="upload-title">
        {t('ai_profile.analyzing_your_files')}
      </div>
      <div className="upload-preloader-bar upload-popup-preloader-bar">
        <InfinityLoader />
      </div>
      <Vimeo
        video={getVimeoId()}
        autoplay
        onEnd={onEnd}
        onPlay={() => app.sendGoogleAnalyticsEvent(GA.category, GA.events.startVideo, { name: 'Upload file video started' })}
        style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
      />
      {onSkip ? (
        <div className="skip">
          <Button theme={THEMES.LIGHT} forwardIcon={NextIcon} title={t('general.skip')} action={onSkip} />
        </div>
      ) : null}
    </div>
  );
};

AiAnimate.propTypes = {
  onSkip: PropTypes.func,
  onEnd: PropTypes.func,
};
